<template>
  <div class="activity container-fluid" :activity_id="id">
    <div class="row">
      <div style="display: flex;">
        <div style=""><img class="activity_type" :src="imgUrl" style="max-width: 77px; height: auto;" /></div>
        <div style="flex: 1; padding-left: 2rem;" class="dropdown">
          <span class="activity_title">{{activity.name}}</span>
          <span v-if="isTeacher">
            <a class="dropdown-toggle btn-edit" data-toggle="dropdown" href="#"><i class="fa fa-edit"></i></a>
            <div class="dropdown-menu" style="padding: 0;">
              <div class="list-group" style="margin-bottom: 0;">
                <a class="list-group-item" @click="showEditModal">編輯</a>
                <a class="list-group-item" @click="deleteAct">刪除</a>
              </div>
            </div>
            <EditActivityModal ref="editModal" :activity="activity"/>
          </span>
        </div>
      </div>
      <div class="col-md-3 col-xs-6">
      </div>
      <div class="col-md-9 col-xs-6" style="display: grid; align-content: center; height: 100%;">
      </div>
      <div class="col-xs-12 activity_content">{{activity.description}}</div>
    </div>
    <div v-if="isTeacher" class="row complete_rate">
      <div class="col-xs-8" style="margin-top:25px;">
        班級進度: <span class="complete_rate_num">{{completion_rate}}%</span>
      </div>
      <div class="col-xs-4">
        <ChartDonut :percent="completion_rate"/>
      </div>
    </div>
    <div v-else class="row complete_rate">
      <div class="col-xs-4 col-md-push-8">
          <i v-if="isStudent && activity.isDone" class="material-icons" style="font-size: 48pt;">check_circle_outline</i>
      </div>
    </div>
    <div style="text-align: right; margin: 20px 0;">
        <router-link v-if="activity.permissions.can_access" :to="{name: 'ClassActivity', query: {course: courseId, week: weekId, activity: id}}" class="details">查看</router-link>
    </div>
  </div>
</template>
<style scoped>
  .details {
    display: inline-block;
    /*width: 30%;*/
    color: white !important;
    background-color: rgb(142, 202, 147);
    text-align: center;
    border-radius: 8px;
    padding: 10px;
  }
  .details:hover{
    text-decoration: unset;
  }
  @media (max-width: 991px){
  .navbar-nav > li > .dropdown-menu, .dropdown .dropdown-menu {
      -webkit-transform: unset !important;
      -moz-transform: unset !important;
      -o-transform: unset !important;
      -ms-transform: unset !important;
      transform: unset !important;
    }
  }
</style>
<script>
import ChartDonut from '@/components/Utility/ChartDonut'
import EditActivityModal from '@/components/Weeks/EditActivityModal'
export default {
  components: {
    ChartDonut,
    EditActivityModal
  },
  props: {
    activity: Object
  },
  data () {
    return {
      courseId: this.$parent.courseId,
      weekId: this.$parent.weekId,
      id: this.activity.id,
      completion_rate: !isNaN(parseInt(this.activity.completedPercent)) ? parseInt(this.activity.completedPercent.toFixed(0)) : 0,
      imgUrl: require(`@/assets/image/task_${this.activity.type.toLowerCase()}.png`),
      openEditModal: false
    }
  },
  computed: {
    isTeacher: function () {
      return this.$store.getters.isTeacher
    },
    isStudent: function () {
      return this.$store.getters.isStudent
    }
  },
  methods: {
    deleteAct: function () {
      if (confirm('刪除?')) {
        this.$store.dispatch('request', {
          method: 'delete',
          route: `courses/${this.courseId}/weeks/${this.weekId}/activities/${this.id}`
        }).then(() => {
          // this.$parent.deleteActivity(this.activity)
          let index = this.$parent.category.activities.findIndex(a => a.id === this.id)
          this.$parent.category.activities.splice(index, 1)
          alert('成功刪除')
        })
      }
    },
    showEditModal: function () {
      this.$refs.editModal.open()
    }
  }
}
</script>
